/**
 * Growth Report PDF — 화면의 A4 미리보기(794px)를 그대로 그려 PDF 로 만든다 (html2pdf.js = html2canvas + jsPDF).
 * 섹션은 페이지 사이에서 잘리지 않게 넘긴다. 다운로드와 메일 첨부가 같은 모양을 쓴다.
 */
const options = (filename) => ({
  filename,
  margin: [10, 0, 12, 0],
  image: { type: 'jpeg', quality: 0.95 },
  html2canvas: { scale: 2, useCORS: true, backgroundColor: '#ffffff' },
  jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  pagebreak: { mode: ['css', 'legacy'], avoid: ['section', '.break-inside-avoid'] },
});

const load = async () => (await import('html2pdf.js')).default;

export const reportFileName = (name, kind = 'full') =>
  `2days-growth-report-${(name || 'participant')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')}${kind === 'free' ? '-card' : ''}.pdf`;

/** 파일로 내려받기 */
export const savePdf = async (node, filename) => {
  const html2pdf = await load();
  await html2pdf().set(options(filename)).from(node).save();
};

/** 메일 첨부용 Blob */
export const pdfBlob = async (node, filename) => {
  const html2pdf = await load();
  return html2pdf().set(options(filename)).from(node).outputPdf('blob');
};
